<!--suppress ALL -->
<template>
	<div
		class="right check_col check_col3 m_toggle"
		v-bind:class="{ col_disable: this.$store.state.checkoutStage !== 'payment' }"
	>
		<h2 class="check_title" onclick="mobileToggle(this)">
			פרטי תשלום
			<CARD />
			<span class="check_col_plus left"></span>
		</h2>
		<div class="check_col_inner m_toggleInner">
			<div class="group">
				<div class="title_s">סיכום</div>

				<div
					class="birthday-gift cashback toggleContainer"
					v-if="birthdayGiftActive"
					:class="{ active: birthdayGiftActive }"
				>
					<a
						href="javascript:void(0);"
						class="birthday-gift-title cashback-title not-inclusive"
						onclick="toggle(this)"
					>
						<Ballon />
						{{ birthday.title }}
						<span class="sep-plus"></span>
					</a>
					<div class="toggleInner" :class="{ open_toggle: birthdayGiftActive }">
						<div class="cashback-open cupon_open">
							<div>
								<div class="birthday-gift-content" v-html="birthday.content"></div>
								<div v-if="!birthdayUsed">
									<button
										class="btn"
										:class="{ loading: birthdayLoading }"
										type="button"
										@click="applyBirthdayGift()"
									>
										<span>מימוש מתנה</span>
										<img
											v-if="birthdayLoading"
											class="gc-loader"
											:src="wpData.assets_url + '/svg/loader.svg'"
											alt=""
										/>
									</button>
									<div
										class="birthday-gift-error error_tx"
										v-if="birthdayError"
										v-html="birthdayError"
									></div>
								</div>
								<div class="birthday-success" v-else><OK />{{birthday.success_message}}</div>
							</div>
						</div>
					</div>
				</div>

				<div
					class="cashback toggleContainer"
					:class="{ active: cashback.process.pointsUsed || cashback.process.pointsTotal }"
				>
					<a href="javascript:void(0);" class="cashback-title not-inclusive" onclick="toggle(this)">
						<Cashback />
						כרמלה קאשבק
						<span class="sep-plus"></span>
					</a>
					<div
						class="toggleInner"
						:class="{ open_toggle: cashback.process.pointsUsed || cashback.process.pointsTotal }"
					>
						<div class="cashback-open">
							<div v-if="cashback.points && !cashback.process.pointsUsed">
								<div>
									צברת {{ cashback.process.pointsTotal }} נק', ששוות {{ getCashbackPointsWorth }} ₪
								</div>
								<div class="form_input">
									<div>
										<input
											v-model="cashback_points_to_redeem"
											name="cashback_points_to_redeem"
											type="number"
											placeholder="אז כמה נק' להמיר?"
											min="1"
											:max="
												Math.min(
													cashback.process.pointsTotal,
													parseFloat(subTotalWithoutCashback)
												)
											"
											@input="validateCashbackAmount"
										/>
										<div class="points-calc" :class="{ show: cashback_points_to_redeem > 0 }">
											=
											{{
												(this.cashback_points_to_redeem / cashback.options.worth) | currency("")
											}}
											₪
										</div>
									</div>
									<button class="btn" type="button" @click="applyCashback()">המרה לכסף</button>
								</div>
							</div>
							<div v-else-if="cashback.process.pointsUsed">
								מימשת {{ cashback.process.pointsUsed }} נקודות בשווי {{ getCashbackUsedPointsWorth }} ₪
							</div>
							<div v-else class="no-points">
								אין לך פה נקודות עדיין,<br />
								אבל בפעם הבאה כבר יהיו לך!
							</div>
							<div v-if="cashback_minimum_error" class="cashback-error">
								ממש עוד קצת! כשיהיו לך {{ cashback.options.minimum_points }} נקודות ומעלה, יהיה אפשר
								להמיר אותן לכסף.
							</div>
						</div>
					</div>
				</div>

				<div
					class="cupon_row toggleContainer active"
					:class="{ active: typeof this.$store.state.coupon == 'string' && !birthdayGiftActive }"
				>
					<div class="cupon_top">
						<a href="javascript:void(0);" class="not-inclusive" onclick="toggle(this)">
							מימוש קופון / גיפט קארד
							<COUPON />
							<span class="sep-plus"></span>
						</a>
					</div>
					<div
						class="clearfix toggleInner"
						:class="{
							open_toggle:
								(typeof this.$store.state.coupon == 'string' && this.$store.state.coupon) ||
								(this.$store.state.coupon && !coupon_loaded),
						}"
					>
						<div class="cupon_open">
							<div class="right form_input">
								<input
									v-model="coupon"
									:class="{ error: coupon_error }"
									name="coupon"
									type="text"
									placeholder="הזן קופון או גיפט קארד"
								/>
								<input v-model="selectedCoupon" name="couponCode" type="hidden" />
								<input type="hidden" name="gift_card_id" v-model="giftCard.id" />
								<input type="hidden" name="gift_card_balance" v-model="giftCard.balance" />
							</div>
							<div class="right submit_bt ease">
								<a href="#" v-if="!couponIsLoading" @click.prevent="validateCoupon">למימוש</a>
								<a href="#" v-if="couponIsLoading">
									<img class="gc-loader" :src="wpData.assets_url + '/svg/loader.svg'" alt="" />
								</a>
							</div>
							<div class="coupon-error error_tx" v-if="coupon_error" v-html="coupon_error"></div>

							<!-- GIFT CARD UI -->
							<div class="gift-card-row" v-if="giftCard">
								<p class="gc-title">{{ gcOptions.gc_box_title }}</p>
								<p class="gc-balance">
									{{ gcOptions.gc_box_pre_balance }} ₪<b>{{ giftCard.balance.toFixed(2) }}</b>
								</p>
								<p class="gc-legal">
									{{ gcOptions.gc_box_text }}
								</p>
								<a class="gc-remove" @click="removeGiftCard">{{ gcOptions.gc_box_remove }}</a>
							</div>
							<!-- END OF | GIFT CARD UI -->
						</div>
					</div>
				</div>
				<div class="total_table">
					<div class="total_row clearfix">
						<div class="right total_table_tx">מוצרים</div>
						<div class="left total_table_price" :data-products-price="total">
							{{ total | currency("") }} ₪
						</div>
					</div>
					<div class="total_row clearfix" v-if="typeof $store.state.coupon == 'object'">
						<div class="right total_table_tx">
							{{ selectedCoupon == "birthday" ? "הטבת יום הולדת" : "קופון " + selectedCoupon }}
							<a href="#" @click.prevent="$store.commit('setCoupon', '')">הסר</a>
							<span>{{ $store.state.coupon.description }}</span>
						</div>
						<div class="left total_table_price" :data-coupon-code="$store.state.coupon.code">
							{{ couponSave | currency("") }} ₪ -
						</div>
					</div>
					<div class="total_row clearfix" v-if="cashback.process.pointsUsed">
						<div class="right total_table_tx">
							קאשבק: {{ cashback.process.pointsUsed }} נקודות
							<a href="#" @click.prevent="resetCashbackPoints">הסר</a>
						</div>
						<div class="left total_table_price">{{ getCashbackUsedPointsWorth | currency("") }} ₪ -</div>
					</div>
					<div
						class="total_row clearfix"
						v-if="(shipmentPrice == 0 && this.$store.state.orderIsDonation) || shipmentPrice != 0"
					>
						<div class="right total_table_tx">דמי משלוח</div>
						<div class="left total_table_price" :data-shipping-price="0" v-if="shipmentPrice == 0">
							עלינו
						</div>
						<div
							class="left total_table_price"
							:data-shipping-price="shipmentPrice"
							v-if="shipmentPrice > 0"
						>
							{{ shipmentPrice | currency("") }} ₪
						</div>
					</div>

					<!-- GIFT CARD DISCOUNT -->
					<div class="total_row clearfix" v-if="giftCard">
						<div class="right total_table_tx">
							{{ gcOptions.gc_line_item_name }}
							<!-- <a href="#" @click.prevent="$store.commit('setCoupon','')">הסר גיפט קארד</a> -->
							<a href="#" @click.prevent="removeGiftCard">{{ gcOptions.gc_box_remove }}</a>
							<span>* {{ gcOptions.gc_line_item_notice }}</span>
						</div>
						<div class="left total_table_price">{{ giftCardUsageInThisOrder }} ₪ -</div>
					</div>
					<!-- END OF | GIFT CARD DISCOUNT -->

					<div class="total_row clearfix">
						<div class="right total_table_tx">סה”כ (שיערוך)</div>
						<div class="left total_table_price" :data-checkout-total-price="subTotal">
							{{ subTotal | currency("") }} ₪
						</div>
					</div>
				</div>
				<div class="text">
					העלות הסופית לחיוב תיקבע לאחר שקילת המוצרים ביום משלוח ההזמנה. המחירים מעודכנים לתאריך {{ nowDate }}
				</div>
			</div>
			<div
				class="group"
				:class="{ proccessing: loadingCards }"
				v-if="
					(userCheckoutInfo && !userCheckoutInfo.paylater && !isOrderEdit && !isPermenentEdit) ||
					(!userLogged && !isOrderEdit)
				"
			>
				<span style="display: block; text-align: center" v-if="loadingCards">טוען שיטות תשלום</span>
				<div class="title_s">שיטת תשלום</div>
				<div class="pay_row clearfix" v-for="(card, index) in cards" :key="index">
					<div class="right form_check form_radio">
						<label class="form_check_tx">
							כרטיס אשראי שמסתיים בספרות {{ card.card }} בתוקף עד {{ card.expiredate }}
							<input
								type="radio"
								:checked="index == 0 ? '1' : false"
								name="billing_payment_card"
								:value="card.id"
							/>
							<span class="checkmark"></span>
						</label>
					</div>
					<div class="left green_link">
						<a href="#" @click.prevent="removeCard(card.id)">הסר</a>
					</div>
				</div>
				<div class="pay_row clearfix">
					<div class="form_check form_radio" v-if="cards && cards.length > 0">
						<label class="form_check_tx">
							אמצעי תשלום חדש / נוסף (יישמר להזמנות עתידיות)
							<input type="radio" name="billing_payment_card" value="new" />
							<span class="checkmark"></span>
						</label>
					</div>
					<div class="form_check form_radio" v-if="cards && cards.length > 0 && !this.isPermenent">
						<label class="form_check_tx">
							אמצעי תשלום חד פעמי (לא יישמר)
							<input type="radio" name="billing_payment_card" value />
							<span class="checkmark"></span>
						</label>
					</div>

					<template v-if="!isPermenent && !giftCard">
						<div class="form_check" v-if="(!cards || cards.length == 0) && !loadingCards">
							<label class="form_check_tx">
								זכור את אמצעי התשלום להזמנה מהירה ובטוחה בעתיד
								<input type="checkbox" name="billing_payment_card" value="new" />
								<span class="checkmark"></span>
							</label>
						</div>
					</template>
					<template v-else>
						<div class="form_check" v-if="cards && cards.length == 0 && !loadingCards && !giftCard">
							<label class="form_check_tx">
								עם השלמת ההזמנה ומילוי פרטי האשראי ברור לי שפרטי התשלום יישמרו להזמנות עתידיות
								<input
									type="checkbox"
									name="billing_payment_card"
									v-validate="'required'"
									value="new"
								/>
								<span class="checkmark"></span>
							</label>
							<div class="error_tx" v-if="save_card_error">
								סורי.. לא ניתן להפעיל את שירות הזמנה קבועה בלי האישור הזה
							</div>
						</div>
					</template>

					<div class="pay_secure">
						<LOCK />
						<span class="bold">קנייה בטוחה: </span> כרמלה עומדת בתקני אבטחת המידע המחמירים ביותר של חברות
						האשראי ופרוטוקול האבטחה (SSL PCI DSS L1)
						<a-div style="margin: 0 5px" :href="wpData.terms_page" :force-new="true">לפרטים נוספים</a-div>
					</div>
				</div>
			</div>
			<div
				class="group"
				:class="{ proccessing: loadingCards }"
				v-if="
					(userCheckoutInfo && !userCheckoutInfo.paylater && isOrderEdit) ||
					(userLogged && isOrderEdit) ||
					(userLogged && isPermenentEdit)
				"
			>
				<div class="title_s">שיטת תשלום</div>
				<div class="pay_row clearfix">
					<div class="form_check form_radio">
						<label class="form_check_tx">
							עדכון אמצעי תשלום חדש
							<input type="checkbox" name="billing_payment_card" value="new" />
							<span class="checkmark"></span>
						</label>
					</div>
					<div class="pay_secure">
						<LOCK />
						<span class="bold">קנייה בטוחה: </span> כרמלה עומדת בתקני אבטחת המידע המחמירים ביותר של חברות
						האשראי ופרוטוקול האבטחה (SSL PCI DSS L1)
						<a-div style="margin: 0 5px" :href="wpData.terms_page" :force-new="true">לפרטים נוספים</a-div>
					</div>
				</div>
			</div>

			<input type="hidden" name="_wpnonce" :value="this.$wpData.checkout_nounce" />
			<input type="hidden" name="products" v-model="cartJSON" />
			<input type="hidden" name="payment_method" value="paylater" />
			<input type="hidden" name="orderAs" :value="orderAsEmail" />
			<input type="hidden" name="docNumber" v-if="$store.state.orderEdit" :value="$store.state.orderEdit" />
			<input
				type="hidden"
				name="edit_order"
				v-if="$store.state.orderEdit"
				:value="$store.state.orderEditMeta.orderID"
			/>
			<input type="hidden" name="per_order" v-if="$store.state.createPermenantOrder" value="1" />
			<input
				type="hidden"
				name="permenentOrderID"
				v-if="isPermenent && isPermenentEdit"
				:value="this.$store.state.permenantOrderEdit.id"
			/>
			<input type="hidden" name="shipping_method" :value="shippingMethod" />
			<input type="hidden" name="permenent_order" v-if="isPermenent" value="1" />
			<input type="hidden" name="emergency_mode[comax]" v-if="this.emergency_mode.comax" value="1" />
			<input type="hidden" name="emergency_mode[officecore]" v-if="this.emergency_mode.officecore" value="1" />

			<label
				class="form_check"
				v-if="
					!this.$store.state.userLogged ||
					this.$store.state.userLoggedInfo.terms != '1' ||
					this.$store.state.isAdmin
				"
			>
				<div class="form_check_tx">
					קראתי ואישרתי את
					<a-div :force-new="true" :href="this.$wpData.terms_page">תנאי שימוש</a-div>
					<input type="checkbox" name="terms" v-validate="'required'" value="קראתי ואישרתי את תנאי השימוש" />
					<span class="checkmark"></span>
				</div>
				<div class="error_tx">{{ errors.first("terms") }}</div>
			</label>

			<label
				class="form_check"
				v-if="!this.$store.state.userLogged || this.$store.state.userLoggedInfo.subscribed != '1'"
			>
				<div class="form_check_tx">
					אני רוצה לקבל עדכונים לגבי מבצעים והפתעות עונתיות במייל
					<input type="checkbox" name="account_subscribe" checked value="1" />
					<span class="checkmark"></span>
				</div>
			</label>

			<div class="bt_green submit_bt ease">
				<input type="submit" :value="payButtonText" />
			</div>
			<div class="error_message" v-if="errorText">
				<div class="message" v-html="errorText"></div>
				<router-link :to="'/שירות-לקוחות/'">צריכים עזרה? ניתן לפנות אלינו כאן</router-link>
			</div>
			<div
				v-if="errors.items.length > 0"
				class="error_tx mobile_only"
				style="text-align: center; margin-top: 5px"
			>
				יש למלא את כל השדות המסומנים
			</div>
			<div class="error_tx" style="text-align: center; margin-top: 5px" v-if="isOrderEdit">
				זה בסדר, בעריכת הזמנה אנחנו לא צריכים שוב את האשראי
			</div>
			<div class="small_note">
				עם השלמת שליחת ההזמנה את.ה מאשר.ת את
				<a-div :href="wpData.terms_page" :force-new="true">תנאי השימוש ומדיניות הפרטיות</a-div>
				באתר.
			</div>
			<input type="hidden" id="gtm_session_id" name="gtm_session_id" :value="get_gtm_session_id()" />
			<input type="hidden" id="gtm_client_id" name="gtm_client_id" :value="get_gtm_client_id()" />
		</div>
	</div>
</template>
<script>
	import moment from "moment";

	import LOCK from "../../assets/img/lock.svg";
	import CARD from "../../assets/img/card.svg";
	import COUPON from "../../assets/img/cupon.svg";
	import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
	import ExitPop from "../Popups/ExitSalePop";
	import Cashback from "@/assets/img/cashback-small.svg";
	import Ballon from "@/assets/img/ballon.svg";
	import OK from "@/assets/img/ok.svg";

	export default {
		props: {
			errorText: {},
		},
		data() {
			return {
				shipmentCost: wpData.shipment_cost,
				cards: [],
				savedCards: [],
				loadingCards: false,
				wpData: wpData,
				coupon: "",
				numOfModals: 0,
				checkedProducts: true,
				coupon_error: "",
				orderAs_email: "",
				coupon_loaded: false,
				popupProducts: [],
				showedPopupProducts: false,
				save_card_error: false,
				giftCard: false,
				couponIsLoading: false,
				gcOptions: wpData.globalOptions.gc_page_mimush,
				cashback: this.$store.state.cashback,
				cashback_minimum_error: false,
				cashback_points_to_redeem:
					this.$store.state.cashback.process.pointsUsed > 0
						? this.$store.state.cashback.process.pointsUsed
						: null,
				birthday: wpData.globalOptions.birthday_gift,
				birthdayLoading: false,
				birthdayError: "",
			};
		},
		watch: {
			sentCart: function (newValue, oldValue) {
				if (newValue) {
					this.coupon = "";
					this.$nextTick(() => {
						if (typeof this.$store.state.coupon == "string") {
							if (this.$store.state.coupon != "") {
								this.coupon = this.$store.state.coupon;
								this.validateCoupon();
							}
						}
						if (typeof this.$store.state.coupon == "object") {
							this.coupon = this.$store.state.coupon.code;
							this.validateCoupon();
						}
					});
				}
			},
			numOfModals: function (count) {
				if (typeof this.popupProducts[0] != "undefined" && typeof this.popupProducts[0] == "object") {
					this.showPopupSale(this.popupProducts[0]);
				} else if (typeof this.popupProducts[0] == "undefined" && this.showedPopupProducts) {
					this.checkedProducts = false;
					this.checkProductsFromServer();
				}
			},
			popupProducts: function (array) {
				if (typeof array != "undefined" && array.length) {
					this.numOfModals = array.length;
				} else {
					this.numOfModals = 0;
				}
			},
			finishedChekingCart: function (value) {
				if (value) {
					$(".submit_bt input").click();
				}
			},
		},
		computed: {
			...mapState(["userLoggedInfo", "userLogged", "sentCart"]),
			...mapGetters(["cartJSON", "userCheckoutInfo", "getCashbackPointsWorth", "getCashbackUsedPointsWorth"]),
			payButtonText() {
				if (this.isOrderEdit || this.isPermenentEdit) {
					return "שליחת הזמנה ערוכה וסיום";
				}
				if (this.giftCard) {
					return wpData.globalOptions.gc_page_mimush.pay_button_text;
				}
				return "המשך לתשלום באמצעות כרטיס אשראי";
			},
			shipmentPrice() {
				if (this.$store.state.orderIsDonation || this.$store.state.localPickup) {
					return 0;
				}
				return this.shipmentCost;
			},
			shippingMethod() {
				if (this.$store.state.localPickup) {
					return "local_pickup:2";
				}
				return "flat_rate:1";
			},
			finishedChekingCart() {
				if (this.checkedProducts && this.numOfModals === 0) {
					return true;
				}
				return false;
			},
			orderAsEmail() {
				if (this.userCheckoutInfo.newUser) {
					return "0";
				}
				return this.userCheckoutInfo.email;
			},
			isPermenent() {
				if (this.$store.state.createPermenantOrder) {
					return true;
				}
				return false;
			},
			isPermenentEdit() {
				if (typeof this.$store.state.permenantOrderEdit == "object" && this.$store.state.permenantOrderEdit) {
					return true;
				}
				return false;
			},
			nowDate() {
				let todayDate = new Date();
				var mounth = todayDate.getMonth() + 1;
				var day = todayDate.getDate();
				var year = todayDate.getFullYear();
				return `${day}/${mounth}/${year}`;
			},
			total() {
				let total = this.$store.state.added.reduce(
					(total, amount) => total + parseFloat(this.calculatePrice(amount)),
					0
				);
				return parseFloat(total).toFixed(2);
			},
			couponSave() {
				let coupon = this.$store.state.coupon ? this.$store.state.coupon : false;
				let save = 0;
				if (coupon) {
					if (coupon.discount_type == "percent" && coupon.product_ids.length == 0) {
						save = parseFloat(this.total) * (parseFloat(coupon.amount) / 100);
					}
					if (coupon.discount_type == "fixed_cart" && coupon.free_shipping) {
						save = parseFloat(coupon.amount) + parseInt(this.shipmentCost);
					}
					if (coupon.discount_type == "fixed_cart" && !coupon.free_shipping) {
						save = parseFloat(coupon.amount);
					}
				}
				return parseFloat(save).toFixed(2);
			},
			cashbackPoints() {
				if (this.getCashbackUsedPointsWorth) {
					return parseFloat(this.getCashbackUsedPointsWorth);
				}
				return 0;
			},
			subTotal() {
				if (this.giftCard) {
					let subtotal = parseFloat(this.total) + parseFloat(this.shipmentPrice);
					let val = subtotal.toFixed(2) - this.couponSave - this.giftCard.balance - this.cashbackPoints;
					return Math.max(val, 0);
				} else {
					let subtotal =
						parseFloat(this.total) + parseFloat(this.shipmentPrice) - this.couponSave - this.cashbackPoints;
					return subtotal.toFixed(2);
				}
			},
			subTotalWithoutCashback() {
				if (this.giftCard) {
					let subtotal = parseFloat(this.total) + parseFloat(this.shipmentPrice);
					let val = subtotal.toFixed(2) - this.couponSave - this.giftCard.balance;
					return Math.max(val, 0);
				} else {
					let subtotal = parseFloat(this.total) + parseFloat(this.shipmentPrice) - this.couponSave;
					return subtotal.toFixed(2);
				}
			},
			subTotalWithoutGiftCard() {
				let subtotal = parseFloat(this.total) + parseFloat(this.shipmentPrice);
				return subtotal.toFixed(2) - this.couponSave;
			},
			giftCardUsageInThisOrder() {
				if (!this.giftCard || !this.giftCard.hasOwnProperty("balance")) {
					return "0.00";
				} else {
					let num = Math.min(this.giftCard.balance, this.subTotalWithoutGiftCard);
					return parseFloat(num).toFixed(2);
				}
			},
			isOrderEdit() {
				if (this.$store.state.orderEdit) {
					return true;
				}

				return false;
			},
			selectedCoupon() {
				if (this.$store.state.coupon) {
					return this.$store.state.coupon.code;
				}
				return;
			},
			emergency_mode() {
				return this.$store.state.emergencyMode;
			},
			birthdayGiftActive() {
				let birthday = this.userLoggedInfo.birthday;
				// if (!birthday) {
				// 	birthday = this.$store.state.formFields.birthday ? this.$store.state.formFields.birthday : '';
				// }

				if (birthday) {
					const date_birthday = moment(birthday).add("day", 1);
					const date = moment();

					if (
						this.birthday.active &&
						date_birthday.month() == date.month() &&
						(!this.userLoggedInfo.birthday_used || ( this.userLoggedInfo.birthday_used && this.isOrderEdit ) )
					) {
						return true;
					}
				}
				if (this.selectedCoupon && this.selectedCoupon == "birthday") {
					this.$store.commit("setCoupon", '');
				}
				return false;
			},
			birthdayUsed() {
				if (this.selectedCoupon && this.selectedCoupon == "birthday") {
					return true;
				}

				return false;
			},
		},
		mounted() {
			this.coupon_loaded = false;
			// if (this.$wpData.coupon_code) {
			//   this.coupon = this.$wpData.coupon_code;
			//   this.validateCoupon();
			// }
			// this.$ajax.get(ajaxUrl + "?action=getCards&orderAs="+this.orderAsEmail).then(res => {
			//   this.cards = res.data.cards;
			//   this.loadingCards = false;
			// }).catch(e => console.log(e));
			this.cards = this.$store.state.orderAs
				? this.$store.state.orderAs.saved_cards
				: this.$store.state.userLoggedInfo.saved_cards;

			let _self = this;

			if (this.$store.state.giftcard) {
				this.giftCard = this.$store.state.giftcard;
			}

			$("form .submit_bt input").on("click", function (e) {
				_self.save_card_error = false;
				let checked = $("input[name=terms]").length > 0 ? $("input[name=terms]")[0].checked : true;
				if (!checked) {
					e.preventDefault();
					_self.$validator
						.validate()
						.then((res) => {})
						.catch((e) => console.log(e));
					return;
				}
				if (!_self.checkedProducts && !_self.$store.state.createPermenantOrder) {
					e.preventDefault();
					$(".submit_bt").addClass("proccessing");
					_self.checkProductsFromServer();
				} else {
					if (_self.isPermenent) {
						let save_card =
							$("input[name=billing_payment_card]").length > 0
								? $("input[name=billing_payment_card]:checked")[0].value
								: true;

						if (!save_card) {
							e.preventDefault();
							_self.save_card_error = true;
							_self.$validator
								.validate()
								.then((res) => {})
								.catch((e) => console.log(e));
							return;
						}
					}
					_self.$validator
						.validate()
						.then((res) => {})
						.catch((e) => console.log(e));
					$(".submit_bt").addClass("proccessing");
				}
			});

			if (this.$store.state.sentCart == true) {
			}

			this.$root.$on("popupClosed", () => {
				this.numOfModals--;
				if (this.popupProducts.length > 0) {
					this.popupProducts.splice(0, 1);
				}
			});
			// this.$root.$on('popupOpened', () =>{
			//   this.numOfModals++;

			// })

			this.$ajax.post(ajaxUrl + "?action=update_emergency_mode").then((res) => {
				if (res.data) {
					this.setEmergencyMode(res.data);

					if (this.emergency_mode.comax) {
						this.userCheckoutInfo.paylater = true;
					} else {
						if (!this.userCheckoutInfo.paylater) {
							this.userCheckoutInfo.paylater = false;
						}
					}
				}
			});
		},
		methods: {
			...mapActions(["resetCashbackPoints"]),
			...mapMutations(["setEmergencyMode"]),
			validateCoupon() {
				this.couponIsLoading = true;
				this.coupon_error = "";
				let data = new FormData();
				data.append("coupon", this.coupon);
				data.append("products", this.cartJSON);
				this.$ajax
					.post("?checkCoupon", data)
					.then((res) => {
						this.couponIsLoading = false;
						if (res.data.success) {
							// If its a gift card response handle it
							if (res.data.data.hasOwnProperty("card_id")) {
								return this.handleGiftCard(res.data.data);
							}
							this.$store.commit("setCoupon", res.data.data);
							this.coupon = "";
							this.coupon_loaded = true;
							return;
						} else {
							this.coupon_error = res.data.data;
							this.coupon_loaded = false;
							//this.$store.commit("setCoupon", "");
							return;
						}
					})
					.catch((e) => () => {
						this.couponIsLoading = false;
					});
			},
			handleGiftCard(data) {
				this.giftCard = {
					id: data.card_id,
					balance: data.balance,
				};
				// Remove saved credit cards
				this.savedCards = this.cards;
				this.cards = [];
				return true;
			},
			removeGiftCard() {
				this.giftCard = false;
				this.cards = this.savedCards;
			},
			checkProductsFromServer() {
				var ship_time = document.querySelector("input[name=ship_time]").value;
				//var $form = $('#checkout');
				//console.log($form.find('input[name=billing_email]'));
				var email = "";
				if (typeof this.userCheckoutInfo == "object" && this.userCheckoutInfo) {
					email = this.userCheckoutInfo.email;
				} else {
					email = document.querySelector("input[name=billing_email]").value;
				}
				var cart = this.$store.getters.cartJSON;
				var data = new FormData();
				data.append("action", "checkCart");
				data.append("shipping", ship_time);
				data.append("products", cart);
				data.append("email", email);
				this.$ajax({
					method: "POST",
					url: ajaxUrl,
					data: data,
				})
					.then((response) => {
						if (response.data.products) {
							this.showedPopupProducts = true;
						} else {
							this.showedPopupProducts = false;
						}
						var productsArray = response.data.products;
						this.popupProducts = productsArray;
						this.checkedProducts = true;
					})
					.catch((e) => {
						this.checkedProducts = true;
						$(".submit_bt").removeClass("proccessing");
					});
			},
			calculatePrice(product) {
				if (typeof product.giftedProduct != "undefined") {
					return parseFloat(product.salePriceTotal).toFixed(2);
				}
				if (typeof product.salePriceTotal != "undefined" && product.salePriceTotal > 0) {
					return parseFloat(product.salePriceTotal).toFixed(2);
				}
				if ((product.type === "both" || product.type === "unitaskg") && product.selected === "unit") {
					return parseFloat(
						product.quantity * product.weight * parseFloat(product.price) * product.divide_by
					).toFixed(2);
				}
				return parseFloat(product.quantity * parseFloat(product.price) * product.divide_by).toFixed(2);
			},
			showPopupSale(data) {
				if (typeof data != "undefined" && data) {
					var products = data.productsToShow;
					var productToRemove = data.productToRemove;
					let product_in_cart = this.$store.state.added.find((p) => p.id == productToRemove);
					var missing = false;
					var wanted = false;
					if (typeof product_in_cart != "undefind") {
						if (data.in_stock) {
							wanted = product_in_cart.quantity;
							missing = product_in_cart.quantity - data.in_stock;
							product_in_cart.quantity = data.in_stock;
							this.$store.dispatch("updateCart", [product_in_cart]);
						} else {
							this.$store.dispatch("removeProduct", [product_in_cart]);
						}
					}
					this.$root.$emit("popupOpened");
					this.$modal.show(ExitPop, {
						products: products,
						title: data.productTitle,
						instock: data.in_stock,
						wanted: wanted,
					});
				}
				return;
			},
			removeCard(id) {
				this.$ajax
					.post(ajaxUrl + "?action=removecard&cardId=" + id)
					.then((res) => {
						if (res.data.return == "Done") {
							let find = this.cards.find((card) => card.id == id);
							let index = this.cards.indexOf(find);
							this.cards.splice(index, 1);
						}
					})
					.catch((e) => console.log(e));
			},
			changeTab(tab) {
				this.done = true;
				this.$store.commit("changeCheckoutStage", tab);
			},
			get_gtm_session_id() {
				if (window.gtm_session_id) {
					return window.gtm_session_id;
				} else {
					return "";
				}
			},
			get_gtm_client_id() {
				if (window.gtm_client_id) {
					return window.gtm_client_id;
				} else {
					return "";
				}
			},
			validateCashbackAmount(e) {
				const amount = parseInt(e.target.value);

				if (amount > e.target.max) {
					this.cashback_points_to_redeem = e.target.max;
				}

				if (amount < 1) {
					this.cashback_points_to_redeem = 1;
				} else if (
					amount > this.$store.state.cashback.process.pointsTotal ||
					amount > parseFloat(this.subTotalWithoutCashback)
				) {
					this.cashback_points_to_redeem = Math.min(
						this.$store.state.cashback.process.pointsTotal,
						parseFloat(this.subTotalWithoutCashback)
					);
				} else {
					this.cashback_points_to_redeem = amount;
				}

				this.cashback_minimum_error =
					this.cashback_points_to_redeem < this.$store.state.cashback.options.minimum_points;
			},
			applyCashback() {
				if (this.cashback_points_to_redeem >= this.$store.state.cashback.options.minimum_points) {
					this.$store.commit("useCashbackPoints", this.cashback_points_to_redeem);
				} else {
					this.cashback_minimum_error = true;
				}
			},
			applyBirthdayGift() {
				if (this.birthdayLoading) {
					return;
				}
				this.birthdayLoading = true;

				const data = new FormData();
				data.append("coupon", "birthday");
				data.append("products", this.cartJSON);
				if (this.$store.state.formFields.birthday) {
					data.append("birthday", this.$store.state.formFields.birthday);
				}

				this.$ajax
					.post("?checkCoupon", data)
					.then((res) => {
						this.birthdayLoading = false;
						if (res.data.success) {
							this.$store.commit("setCoupon", res.data.data);
							return;
						} else {
							this.birthdayError = res.data.data;
							//this.$store.commit("setCoupon", "");
							return;
						}
					})
					.catch((e) => () => {
						this.birthdayLoading = false;
					});
			},
		},
		components: {
			OK,
			LOCK,
			CARD,
			COUPON,
			ExitPop,
			Cashback,
			Ballon,
		},
	};
</script>

<style>
	.small_note {
		font-size: 12px;
		margin-top: 10px;
	}
</style>

<style lang="sass" scoped>
	.form_check
		margin-bottom: 5px
		padding-right: 25px

		.checkmark
			top: 0

	.error_message
		font-size: 17px
		font-weight: bold
		color: red
		text-align: center
		margin-top: 5px

		span.message
			margin-left: 5px

	.gift-card-row
		background: #efede9
		color: #000000
		padding: 1rem
		border-radius: 0.25rem
		// box-shadow: 0 0.25rem 0.5rem rgba(30,130,76,0.25)
		clear: both
		margin: 3rem auto 0.5rem auto

	.gc-title
		font-weight: bold
		font-size: 1rem
		margin-bottom: 0.25rem

	.gc-balance
		margin-bottom: 0
		margin-bottom: 0.5rem
		font-size: 0.85rem

	.gc-legal
		font-size: 0.85rem
		opacity: 0.5

	.gc-remove
		font-size: 0.85rem
		padding: 0.25rem 0
		text-decoration: underline
		color: #363636
		display: block
		cursor: pointer

	.gc-loader
		height: 1.25rem

	.cashback
		padding: 12px 0
		border-top: 1px solid #c2c2c2

		.cashback-title
			color: #1e824c
			font-weight: bold
			display: flex
			column-gap: 5px
			position: relative

		&.active .sep-plus:before
			top: 0
			right: 0
			transform: rotate(0deg)
			transition: all 0.3s ease

		.toggleInner

			&:not(.open_toggle)
				display: none

			.cashback-open
				margin: 5px 0 0

				.form_input
					margin-bottom: 0
					display: flex
					column-gap: 8px
					margin-top: 10px

					> div
						position: relative

						input
							width: 195px
							height: 32px

						.points-calc
							position: absolute
							left: 9px
							top: 1px
							line-height: 32px
							font-size: 14px
							color: #1e824c
							opacity: 0

							&.show
								opacity: 1
								transition: 300ms ease

		button
			color: #fff
			background: #213519
			transition: 300ms ease all
			height: 32px
			padding: 6px 20px
			line-height: 1

			&:hover
				background: #1e824c

		.cashback-error
			font-size: 13px
			color: red
			margin-top: 5px

		.no-points
			line-height: 18px
			margin-bottom: 10px
</style>

<style lang="scss" scoped>
	.birthday-gift {
		.birthday-gift-title {
			svg {
				height: 19px;
				fill: #1e824c;
			}
		}

		.birthday-gift-content {
			margin-bottom: 5px;
		}

		.btn {
			margin: 0;
			width: 114px;

			&:hover {
				background: #1e824c;
				color: #fff;
			}

			&.loading {
				span {
					display: none;
				}
			}
		}
		.birthday-success {
			font-weight: bold;

			svg {
				margin-inline-end: 5px;
				height: 10px;
				fill: #1e824c;
			}
		}
	}
</style>
